import { Fragment, JSX } from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';

interface Step {
  label: string;
  optional?: boolean;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export function OrganizationSteps({ currentStep, steps }: StepIndicatorProps): JSX.Element {
  return (
    <div className="w-full mb-8">
      {/* Circles and connectors row */}
      <div className="flex items-center justify-center gap-4">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;

          let divider;

          if (index < steps.length - 1) {
            divider = (
              <div
                className={clsx('w-16 h-0.5 bg-default-200', 'self-start mt-5', {
                  'bg-success': index < currentStep,
                })}
              />
            );
          }

          return (
            <Fragment key={step.label}>
              <div className="flex flex-col items-center">
                <div
                  className={clsx(
                    'w-10 h-10 flex items-center justify-center rounded-full',
                    'font-semibold text-sm',
                    {
                      'bg-success text-success-foreground': isCompleted,
                      'bg-primary text-primary-foreground': isCurrent,
                      'bg-secondary': !isCompleted && !isCurrent,
                    },
                  )}
                >
                  {isCompleted ? <CheckIcon className="h-5 w-5" /> : index + 1}
                </div>
                <p
                  className={clsx('mt-2 text-xs whitespace-nowrap', {
                    'font-medium': isCompleted,
                  })}
                >
                  {step.label}
                </p>
              </div>
              {divider}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
